var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as yaml from 'js-yaml';
import { DominoBuilderError, DominoBuilderErrorScope, DominoBuilderErrorSeverity, DominoBuilderErrorType, } from '../errors';
import { getIsActionDefinition, getIsTriggerDefinition, getIsTypeDefinition, } from '../helpers';
import { isPrimitiveType } from '../symbols';
import { typeFetchBlacklist } from '../types';
import { RESOURCE_SCHEMA, } from './types';
export function resourceRegistryWithCache(resourceRegistryClient) {
    const definitionCache = {};
    const getResource = (fqn) => __awaiter(this, void 0, void 0, function* () {
        const cacheHit = definitionCache[fqn];
        if (!!cacheHit) {
            return cacheHit;
        }
        else {
            let resource;
            try {
                // prevent registry hits for known un-registered types
                resource =
                    isPrimitiveType(fqn) || fqn === 'any' || typeFetchBlacklist.has(fqn)
                        ? null
                        : yield resourceRegistryClient.fetchResource(fqn);
            }
            catch (error) {
                throw new DominoBuilderError(DominoBuilderErrorType.ResourceFetchFailure, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, `The definition for resource ${fqn} could not be fetched from the supplied registry`, {
                    path: `ResourceRequest::${fqn}`,
                });
            }
            if (!resource) {
                throw new DominoBuilderError(DominoBuilderErrorType.ResourceNotFound, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, `The definition for resource ${fqn} could not be found in the supplied registry`, {
                    path: `ResourceRequest::${fqn}`,
                });
            }
            let definitionRoot;
            try {
                definitionRoot = yaml.load(resource.definition, {
                    schema: RESOURCE_SCHEMA,
                });
            }
            catch (error) {
                throw new DominoBuilderError(DominoBuilderErrorType.ParseError, DominoBuilderErrorScope.DESIGN, DominoBuilderErrorSeverity.ERROR, `The definition for resource ${fqn} was fetched from the registry but could not be parsed`, {
                    path: `ResourceRequest::${fqn}`,
                });
            }
            let definition;
            if (getIsActionDefinition(definitionRoot)) {
                definition = definitionRoot.action;
            }
            else if (getIsTriggerDefinition(definitionRoot)) {
                definition = definitionRoot.trigger;
            }
            else if (getIsTypeDefinition(definitionRoot)) {
                definition = definitionRoot.type;
            }
            if (!!definition) {
                setResourceToCache(fqn, definition);
            }
            return definition;
        }
    });
    const getResourceFromCache = (fqn) => definitionCache[fqn];
    const setResourceToCache = (name, resource) => {
        definitionCache[name] = resource;
    };
    return {
        getResource,
        getResourceFromCache,
        setResourceToCache,
    };
}
//# sourceMappingURL=resourceRegistryWithCache.js.map